import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import CameraIcon from '../../../Icons/Camera'
import Container from '../Container'

export interface CameraButtonProps {
    color?: string
    size?: number
    filled?: boolean
    shadow?: boolean
    title?: string
    onMouseEnter?: any
    onMouseLeave?: any
    onClick?: any
}

const CameraButton = memo((props: CameraButtonProps) => {
    const {
        color,
        size,
        filled,
        shadow,
        title,
        onMouseEnter,
        onMouseLeave,
        onClick,
    } = props
    return (
        <Container shadow={shadow} title={title}>
            <IconButton
                data-testid="Container__CameraButton"
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={onClick}
            >
                <CameraIcon
                    color={color ?? '#fff'}
                    filled={filled}
                    size={size}
                />
            </IconButton>
        </Container>
    )
})

export default CameraButton
